import React from "react";
import styled from "styled-components";

const PaymentAccordionHeaderBox = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    line-height: 1;
    gap: ${props => props.theme.spacing.spacing16};
`

const IconBox = styled.div`
    border-radius: ${props => props.theme.border.defaultRadius};
`

const PaymentAccordionHeaderText = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-grow: 1;
    font-size: ${props => props.theme.fontSize.h3};
    font-weight: ${props => props.theme.fontWeight.semiBold};
    color: ${props => props.theme.colors.dark};
    
`

interface PaymentAccordionHeaderComponentProps {
    renderIcon: () => React.ReactElement | null;
    title: string | React.ReactElement;
}

export const PaymentAccordionHeaderComponent: React.FC<PaymentAccordionHeaderComponentProps> = (props) => {
    return(
        <PaymentAccordionHeaderBox>
            <IconBox>
                {props.renderIcon()}
            </IconBox>
            <PaymentAccordionHeaderText>
                   {props.title}
            </PaymentAccordionHeaderText>
        </PaymentAccordionHeaderBox>
    )
}
